import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "/api",
  timeout: 200000,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token"); // ✅ 建議統一用 access_token
  const lang = localStorage.getItem("language") || "zh-TW";
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers["accept-Language"] = lang;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // ✅ 網路錯誤（如 server 沒開）時，error.response 是 undefined
    if (!error.response) {
      console.error("❌ 網路錯誤：無法連接後端伺服器", error.message);
      return Promise.reject(error);
    }

    const status = error.response.status;

    // ✅ 僅 401 導回登入頁
    // 2026-06-08 在 /authentication/* 頁面（登入/註冊…）本來就未登入，
    //   登入請求自己回 401 是正常的，不要硬導頁，交給元件自己 catch 顯示錯誤，
    //   否則會把 Google/一般登入的真正錯誤吃掉、變成重載空轉。
    if (status === 401) {
      const onAuthPage =
        typeof window !== "undefined" &&
        window.location.pathname.startsWith("/authentication");
      if (!onAuthPage) {
        console.warn("⚠️ Token 驗證失敗，導回登入頁");
        localStorage.removeItem("access_token");
        window.location.href = "/authentication/sign-in";
      }
    }

  
    if (status === 403) {
      console.warn("🚫 權限不足 / 使用次數達上限", error.response.data?.message);
    }

    if (status === 429) {
      console.warn("請求過於頻繁，請稍後再試。", error.response.data?.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
